import React, { useState, useEffect } from 'react';
import './Home.css';
import { Button, Form, Alert, Spinner } from 'react-bootstrap';
import { API } from 'aws-amplify';
import awsconfig from './aws-exports';
import { useParams, useSearchParams } from "react-router-dom";
import { dict } from "./i18n";
import Footer from "./Footer.js";

API.configure(awsconfig);

const ManageForm = ({ i18n, subscriberResource, setSubscriberResource, action }) => {

    let [submitting, setSubmitting] = useState(false);
    let [showSuccess, setShowSuccess] = useState(false);
    let [showFailure, setShowFailure] = useState(false);

    const isSubscribedInitial = (subscriberResource.status === "OPT_IN" || (action === "OPT_IN" && subscriberResource.status === "UNCONFIRMED"))

    let [subscribed, setSubscribed] = useState(isSubscribedInitial)
    let [actionExecuted, setActionExecuted] = useState(false)

    const submitForm = async () => {

        try {
            setSubmitting(true)

            const data = await API.post('scgapi', '/subscribers/' + encodeURIComponent(subscriberResource.subscriber), {
                body: {
                    secret: subscriberResource.secret,
                    status: (subscribed ? "OPT_IN" : "OPT_OUT")
                }
            })

            setSubscriberResource(data)

            console.log("submitted")
            setSubmitting(false)
            setShowSuccess(true)
        } catch (e) {
            console.error("oh noes", e)
            setSubmitting(false)
            setShowFailure(true)
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        await submitForm();
        return false;
    }

    useEffect(() => {
        if (!actionExecuted && action === "OPT_IN" && subscriberResource.status === "UNCONFIRMED") {
            submitForm()
                .catch(console.error)
        }
        // only ever do anything on first load
        setActionExecuted(true)
    }, [action])

    return (
        <Form onSubmit={onSubmit} className={"my-4"}>

            {<Form.Group controlId={"isSubscribedCheckbox"}>
                <Form.Check type={"checkbox"}
                    onChange={(e) => setSubscribed(e.target.checked)}
                    disabled={submitting}
                    defaultChecked={subscribed}
                    label={<div>
                        <h5>{i18n.PROP_65_WARNING_2}</h5>
                        <p>{i18n.ACTIVATEDBY}</p>
                    </div>}
                />
            </Form.Group>}

            <p className="mb-4">
                {i18n.UPDATE_YR_SUB}
            </p>

            {showSuccess && <Alert variant={"success"} onClose={() => setShowSuccess(false)} dismissible>
                <p>{i18n.PREF_SAVED}{subscriberResource.status === "OPT_IN" ? "in" : "out"}.</p>
            </Alert>}

            {showFailure && <Alert variant={"danger"} onClose={() => setShowFailure(false)} dismissible>
                <p>{i18n.UNEXPECTED_ERROR}</p>
            </Alert>}

            {<Button variant="primary" type={"submit"} disabled={submitting}>
                {!submitting ? i18n.SAVE_PREFERENCES : <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />}
            </Button>}
        </Form>
    )
}

const Manage = ({ i18n, subscriberResource, setSubscriberResource, action }) => {
    return (

        <div className="App">

            <div className="px-4 py-5 my-5 mx-auto text-left col-lg-6 col-md-8">

                <h2>
                    {i18n.ALISO_CANYON_PROP65_WARNING}
                </h2>

                <h3 className="display-7 fw-bold my-4">
                    {i18n.SUBSC_PREF}
                </h3>

                <h4 >
                    {i18n.EMAIL_ADDR} {subscriberResource.subscriber}
                </h4>

                <p>{i18n.OPT_OUT_MESG}</p>

                <ManageForm i18n={i18n} subscriberResource={subscriberResource} setSubscriberResource={setSubscriberResource} action={action} />
            </div>
            <div style={styles.footer}>
                <Footer />
            </div>
        </div>
    )
}

const ManageScreen = () => {
    let params = useParams();
    let [searchParams, setSearchParams] = useSearchParams();
    const subscriberId = params.subscriber;
    const action = searchParams.get("action");
    const secret = searchParams.get("_");
    let [i18n, seti18n] = useState(dict['en_us']);
    let [language, setLang] = 'en_us';

    const [subscriberResource, setSubscriberResource] = useState(null)
    useEffect(() => {
        // @TODO if they came in with an action to opt in or out, fire that off rather than a simple GET

        const fetchSubscriberData = async (subscriberId, secret) => {
            const data = await API.get('scgapi', '/subscribers/' + encodeURIComponent(subscriberId) + '?_=' + secret, {})
            language = (data && data.lang && data.lang !== '') ? data.lang : 'en_us'
            seti18n(dict[language]) // set this first
            setSubscriberResource(data)
        }

        if (!subscriberId || !secret) {
            console.log("skipping fetch due to bad request")
            return false
        }

        fetchSubscriberData(subscriberId, secret)
            .catch(console.error)
    }, [subscriberId, secret])

    if (!subscriberId || !secret) {
        return <div className={"d-flex justify-content-center align-content-center"} style={{ height: '100vh' }}>
            <h1>{i18n.INVALID_REQUEST}</h1>
        </div>
    }
    if (subscriberResource !== null && !("subscriber" in subscriberResource)) {
        // @TODO there was an error, but what kind?
        return <div className={"d-flex justify-content-center align-content-center"} style={{ height: '100vh' }}>
            <h1>{i18n.UNEXPECTED_ERROR}</h1>
        </div>
    }
    if (subscriberResource && "subscriber" in subscriberResource) {
        return (<Manage i18n={i18n} subscriberResource={subscriberResource} setSubscriberResource={setSubscriberResource} action={action} />)
    }

    return (<div className={"d-flex justify-content-center align-content-center"} style={{ height: '100vh' }}>
        <Spinner
            className={"my-auto"}
            as="div"
            animation="border"
            size="lg"
            role="status"
            aria-hidden="true"
        />
    </div>)

}
const styles = {
    header: {
        minHeight: "10vh",
    },
    body: {
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 20
    },
    disclaimer: {
        paddingTop: 30,
        paddingBottom: 10
    },
    footer: {
        borderTop: "1px solid #eee"
    },
}
export default ManageScreen;